export enum FilterTypeAction {
  SELECTED_UUID = 'selectedUUID',
  CUSTOM_PARAM = 'customParam'
}
